import { palette } from './palette'

export interface DesignSystemTokens {
  buttonSecondaryBg: string
  buttonSecondaryBorderColor: string
  buttonSecondaryColor: string
  buttonSecondaryHoverBg: string
  buttonSecondaryHoverBorderColor: string
  buttonSecondaryActiveBg: string

  buttonTertiaryBg: string
  buttonTertiaryBorderColor: string
  buttonTertiaryColor: string
  buttonTertiaryHoverBg: string
  buttonTertiaryHoverBorderColor: string
  buttonTertiaryActiveBg: string

  buttonDisabledBg: string
  buttonDisabledBorderColor: string
  buttonDisabledColor: string

  formItemLabelHeight: number
  formItemGap: number

  buttonLinkSecondaryColor: string

  inputAddonGap: number

  actionHoverBorderColor: string
  actionFocusShadow: string

  selectTagHoverBorderColor: string

  cardHoverBorderColor: string

  cellWarningSurface: string
  cellSuccessSurface: string
  cellErrorSurface: string
}

export const customTokens: DesignSystemTokens = {
  buttonSecondaryBg: palette.colorPrimaryBg,
  buttonSecondaryBorderColor: palette.colorPrimaryFocusBorder,
  buttonSecondaryColor: palette.colorPrimary,
  buttonSecondaryHoverBg: palette.colorPrimaryBgHover,
  buttonSecondaryHoverBorderColor: palette.colorPrimary,
  buttonSecondaryActiveBg: palette.colorPrimaryBgActive,

  buttonTertiaryBg: palette.colorNeutralBg,
  buttonTertiaryBorderColor: palette.colorBorder,
  buttonTertiaryColor: palette.colorText,
  buttonTertiaryHoverBg: palette.colorNeutralBgHover,
  buttonTertiaryHoverBorderColor: palette.colorNeutralBorderHover,
  buttonTertiaryActiveBg: palette.colorNeutralBgActive,

  buttonDisabledBg: palette.colorBorder,
  buttonDisabledBorderColor: palette.colorBorder,
  buttonDisabledColor: palette.colorTextDisabled,

  buttonLinkSecondaryColor: palette.colorTextSecondary,

  formItemLabelHeight: 16,
  formItemGap: 4,

  inputAddonGap: 4,

  actionHoverBorderColor: palette.colorPrimaryBorderHover,
  actionFocusShadow: `0 0 0 2px ${palette.colorPrimaryFocusBorder}`,

  selectTagHoverBorderColor: palette.colorSelectTagBorderHover,

  cardHoverBorderColor: palette.colorBorderHover,

  cellWarningSurface: palette.colorWarningSurface,
  cellSuccessSurface: palette.colorSuccessSurface,
  cellErrorSurface: palette.colorErrorSurface
}

declare module 'antd-style' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface CustomToken extends DesignSystemTokens {}
}
